import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const About = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      
      <main className="flex-grow">
        <section className="bg-gradient-to-b from-blue-50 to-white py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="text-4xl font-bold mb-6">How ResumeBoost Works</h1>
              <p className="text-lg text-gray-600">
                Our AI-powered platform helps job seekers optimize their resumes for specific job descriptions,
                increasing their chances of getting past ATS systems and landing interviews.
              </p>
            </div>
          </div>
        </section>

        <section className="py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto space-y-16">
              <div>
                <h2 className="text-2xl font-bold mb-4 flex items-center">
                  <span className="bg-brand-100 text-brand-500 w-8 h-8 rounded-full flex items-center justify-center mr-3">1</span>
                  Create an Account
                </h2>
                <p className="text-gray-600 mb-6">
                  Sign up for a ResumeBoost account to access our AI resume optimization tools. We'll securely store your profile and resume versions.
                </p>
                <img 
                  src="https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80" 
                  alt="Create account" 
                  className="rounded-lg shadow-md w-full"
                />
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4 flex items-center">
                  <span className="bg-brand-100 text-brand-500 w-8 h-8 rounded-full flex items-center justify-center mr-3">2</span>
                  Upload Your Resume
                </h2>
                <p className="text-gray-600 mb-6">
                  Upload your existing resume in PDF or DOCX format. Our system will analyze your skills, experience, and qualifications.
                </p>
                <img 
                  src="https://images.unsplash.com/photo-1498050108023-c5249f4df085"
                  alt="Upload resume" 
                  className="rounded-lg shadow-md w-full"
                />
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4 flex items-center">
                  <span className="bg-brand-100 text-brand-500 w-8 h-8 rounded-full flex items-center justify-center mr-3">3</span>
                  Add Job Description
                </h2>
                <p className="text-gray-600 mb-6">
                  Copy and paste the job description you're applying for. Our AI will identify key requirements, skills, and preferences mentioned in the listing.
                </p>
                <img 
                  src="https://images.unsplash.com/photo-1586282391129-76a6df230234"
                  alt="Add job description" 
                  className="rounded-lg shadow-md w-full"
                />
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4 flex items-center">
                  <span className="bg-brand-100 text-brand-500 w-8 h-8 rounded-full flex items-center justify-center mr-3">4</span>
                  AI Optimization
                </h2>
                <p className="text-gray-600 mb-6">
                  Our AI analyzes both your resume and the job description, then makes strategic adjustments to highlight relevant skills, 
                  use industry-specific keywords, and tailor your experience to match the job requirements. 
                </p>
                <img 
                  src="https://images.unsplash.com/photo-1473091534298-04dcbce3278c"
                  alt="AI optimization" 
                  className="rounded-lg shadow-md w-full"
                />
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4 flex items-center">
                  <span className="bg-brand-100 text-brand-500 w-8 h-8 rounded-full flex items-center justify-center mr-3">5</span>
                  Review and Download
                </h2>
                <p className="text-gray-600 mb-6">
                  Review the optimized resume and make any final adjustments as needed. Once satisfied, download your ATS-optimized resume in PDF or DOCX format.
                </p>
                <img 
                  src="https://images.unsplash.com/photo-1605810230434-7631ac76ec81"
                  alt="Download resume" 
                  className="rounded-lg shadow-md w-full"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="bg-brand-500 text-white py-16">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold mb-6">
              Ready to Optimize Your Resume?
            </h2>
            <p className="text-xl mb-8 max-w-2xl mx-auto">
              Create a tailored resume for each job application and stand out from the competition.
            </p>
            <Link to="/auth/signup">
              <Button size="lg" variant="outline" className="bg-white text-brand-500 hover:bg-brand-50">
                Get Started Now
              </Button>
            </Link>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default About;
